export enum TreeListViewEnum {
  ALL = 'Metadata Dictionary',
  MY_METADATA = 'My Metadata',
  CUSTOM_METADATA = 'Custom Metadata'
}
